<template>
    <div class="box">
        <div class="box-left">
            <my-form
                v-model="form"
                autocomplete="off"
                label-width="80px"
                @submit="submitHandler"
            >
                <el-form-item
                    label="中标金额"
                    prop="costlimit"
                    :rules="newRule('中标金额', 'required')"
                >
                    <el-input
                        class="login-input"
                        v-model="form.costlimit"
                        oninput="value=value.replace(/[^0-9.]/g,'')"
                        clearable
                        autocomplete="off"
                        :placeholder="`请输入中标金额`"
                    >
                        <template slot="append">万元</template>
                    </el-input>
                </el-form-item>

                <el-form-item
                    label="设置类别"
                    prop="agenttype"
                    :rules="newRule('类别', 'required')"
                >
                    <el-radio v-model="form.agenttype" label="1">工程类</el-radio>
                    <el-radio v-model="form.agenttype" label="2">货物类</el-radio>
                    <el-radio v-model="form.agenttype" label="3">服务类</el-radio>
                </el-form-item>

                    <el-form-item
                        label="折扣"
                        prop="discount"
                        :rules="newRule('折扣', 'required')"
                    >
                        <el-input
                            class="login-input"
                            v-model="form.discount"
                            @change="discountHandler"
                            clearable
                            type="number"
                            min="0"
                            autocomplete="off"
                            :placeholder="`请输入折扣`"
                        >
                            <template slot="append">%</template>
                        </el-input>
                    </el-form-item>

                <template slot="btn" slot-scope="scope">
                  <div class="btn-login">
                    <el-button
                      type="primary"
                      @click="scope.submitHandler"
                    >
                      开始计算
                    </el-button>
                  </div>
                </template>
            </my-form>
          <div class="computed-result">
            <div>折扣后代理费：<span>{{ agency }}</span> 元</div>
            <div>标准代理费：<span>{{ standardCost }}</span> 元</div>
          </div>
        </div>

        <div class="box-right">
          <div>
            <el-table
              class="table-res"
              :data="tableData"
              style="width: 100%"
            >
              <el-table-column prop="num" label="计费额" width="150">
              </el-table-column>
              <el-table-column label="收费费率">
                <el-table-column prop="goods" label="货物" min-width="120">
                </el-table-column>
                <el-table-column prop="service" label="服务" min-width="120">
                </el-table-column>
                <el-table-column prop="engineering" label="工程" min-width="120">
                </el-table-column>
              </el-table-column>
            </el-table>
          </div>
          <el-link type="danger" :underline="false">注：货物最高350万元，服务最高300万元，工程最高450万元</el-link>
        </div>
    </div>
</template>

<script>
import rateList from '../config/rate'
export default {
    data() {
        return {
            form: {
                costlimit: "", //中标金额
                discount: 100, //折扣
                agenttype: "1", //类别
            },

            options: [],
            // tableData: [
            //     //费率表
            //     {
            //         num: "0-100万", //计费额
            //         goods: "1.5%", //货物
            //         service: "1.5%", //服务
            //         engineering: "1.0%", //工程
            //     },
            //     {
            //         num: "100万-500万", //计费额
            //         goods: "0.011%", //货物
            //         service: "0.008%", //服务
            //         engineering: "0.007%", //工程
            //     },
            //     {
            //         num: "500万-1000万", //计费额
            //         goods: "0.80%", //货物
            //         service: "0.45%", //服务
            //         engineering: "0.55%", //工程
            //     },
            //     {
            //         num: "1000万-5000万", //计费额
            //         goods: "0.50%", //货物
            //         service: "0.25%", //服务
            //         engineering: "0.35%", //工程
            //     },
            //     {
            //         num: "5000万-1亿", //计费额
            //         goods: "0.25%", //货物
            //         service: "0.10%", //服务
            //         engineering: "0.20%", //工程
            //     },
            //     {
            //         num: "1亿-5亿", //计费额
            //         goods: "0.05%", //货物
            //         service: "0.05%", //服务
            //         engineering: "0.05%", //工程
            //     },
            //     {
            //         num: "5亿-10亿", //计费额
            //         goods: "0.035%", //货物
            //         service: "0.035%", //服务
            //         engineering: "0.035%", //工程
            //     },
            //     {
            //         num: "10亿-50亿", //计费额
            //         goods: "0.008%", //货物
            //         service: "0.008%", //服务
            //         engineering: "0.008%", //工程
            //     },
            //     {
            //         num: "50亿-100亿万", //计费额
            //         goods: "0.006%", //货物
            //         service: "0.006%", //服务
            //         engineering: "0.006%", //工程
            //     },
            //     {
            //         num: "100亿以上", //计费额
            //         goods: "0.004%", //货物
            //         service: "0.004%", //服务
            //         engineering: "0.004%", //工程
            //     },
            // ],
            tableData: rateList,


            agency: "0", //代理费
            standardCost: "0", //标准费用
            dialogVisible: false, //弹框是否隐藏
        };
    },
    methods: {
        submitHandler() {
            this.$get(
                `${this.$store.state.api.webUrl}/navigation/getCalculateData.json`,
                {
                    costlimit: this.form.costlimit,
                    discount: this.form.discount,
                    agenttype: this.form.agenttype,
                    type: "TYPE4",
                },
                (data) => {
                    this.agency = data.discount
                    this.standardCost = data.standard
                }
            );
            this.$emit('startCompute');
        },
        /**
         * 折扣输入框 change 事件
         */
        discountHandler() {
            if (this.form.discount < 0) {
                this.form.discount = 0;
            }
          let discountStr = String(this.form.discount)
          discountStr = discountStr.replace(/[^\d.]/g, "")
            .replace(/^0\d+|^\./g, "")
            .replace(/\.{2,}/g, ".")
            .replace(".", "$#$")
            .replace(/\./g, "")
            .replace("$#$", ".")
            .replace(/^(\d+)\.(\d\d).*$/, "$1.$2");
          this.form.discount = parseFloat(discountStr) || 0;
        },
    },
    mounted() {
    },
};
</script>

<style lang="scss" scoped>
@import '../style/main.scss';

.box {
    width: 100%;
    box-sizing: border-box;
    .coefficient {
        display: block;
        margin-top: -6px;
        margin-left: 80px;
        margin-bottom: 24px;
        color: #606266;
    }
    .select {
        width: 100%;
    }
    .btn-login {
      display: flex;
      justify-content: center;
    }
}

.box > div {
  float: left;
  width: 400px;
}

.box-right {
  width: 520px !important;
  margin-top: -55px;
  margin-left: 100px;
}

.computed-result{
  font-size: 17px;
  font-weight: 600;
  color: #606266;
  div{
    margin-bottom: 15px;
  }
  span{
    color: red;
  }
}
</style>
